module.exports = __webpack_public_path__ + "static/media/20201219_110948_039_IMG_3320.000a5849.jpg";